import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import Modal from "components/v2/Modal/Modal";
import Button from "components/v2/Button/Button";
import { exportProviderListXLSX } from "api";
import errorToast from "helpers/errorToast";
import AnalyticsContext from "../analyticsContext";

type ExportXLSXModalProps = {
  show: boolean;
  onHide: () => void;
};

type AnalyticsContextType = {
  params: any; // Replace 'any' with a specific type if available.
};

function ExportXLSXModal({ show, onHide }: ExportXLSXModalProps) {
  const { params } = useContext(AnalyticsContext) as AnalyticsContextType;
  const { date_from, date_to, date_range } = params;

  const handleRequest = () => {
    const payload = {
      ...params,
      ...(date_range === "custom_date_range"
        ? {
            date_from: moment(date_from, "DD-MM-YYYY").format("YYYY-MM-DD"),
            date_to: moment(date_to, "DD-MM-YYYY").format("YYYY-MM-DD"),
          }
        : {}),
    };

    exportProviderListXLSX(payload)
      .then(() => {})
      .catch((error) => {
        errorToast(error);
      })
      .finally(() => {
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header>
        <div className="text-primary text-xl font-semibold">
          <FormattedMessage id="export.modalTitle" defaultMessage="Export to XLSX" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <br />
        <p>
          <FormattedMessage
            id="export.modalMessage"
            defaultMessage="It might take several minutes to compile your spreadsheet."
          />
        </p>
        <p>
          <FormattedMessage
            id="export.modalMessage2"
            defaultMessage="Once the spreadsheet is available, an e-mail containing the document will be sent to the address linked to your account."
          />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex align-items-center justify-content-end w-100">
          <div className="mr-lg">
            <Button
              label={<FormattedMessage id="general.cancel" defaultMessage="Cancel" />}
              onClick={onHide}
              variant="secondary-gray"
            />
          </div>
          <Button label={<FormattedMessage id="general.request" defaultMessage="Request" />} onClick={handleRequest} />
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ExportXLSXModal;
